import React, { useState } from "react";
import Select from "react-select";

const Step1 = ({ selected, handleStep1Change, setIsOpenModels }) => {
	const [loadError, setLoadError] = useState(false);

	const handleInputChange = (e) => {
		handleStep1Change({ [e.target.id]: e.target.value });
	};
	const handleSelectChange = (opt) => {
		handleStep1Change({ type: opt ? opt.value : "sire" });
	};
	const typeOptions = [
		{ value: "sire", label: "Sire" },
		{ value: "dam", label: "Dam" },
	];
	const currentType =
		typeOptions.find((o) => o.value === selected.type) || typeOptions[0];

	return (
		<div className="step1-container component-card center">
			{loadError && (
				<div className="error-message">
					Unexpected error loading product info. Please reload.
				</div>
			)}

			<div className="left">
				<h2 className="subtitle is-black mb-20">New list</h2>
				<div className="flexer flexer-vcenter">
					<div className="steps mx-10">1</div>
					<span className="input-label">List name</span>
				</div>
				<div
					className="flexer flexer-vcenter"
					style={{ marginTop: 10 }}
				>
					<div className="input-container">
						<label className="input-field__label is-black mb-5">
							Name
						</label>
						<input
							id="name"
							type="text"
							className="input-text"
							placeholder="Text"
							value={selected.name || ""}
							onChange={handleInputChange}
						/>
					</div>
					<div className="input-container ml-20 mt-0">
						<label className="input-field__label is-black mb-5">
							Type
						</label>
						<Select
							options={typeOptions}
							value={currentType}
							onChange={handleSelectChange}
							className="react-select-container"
							classNamePrefix="react-select"
							isClearable={false}
						/>
					</div>
					<i
						className="fas fa-question-circle cursor help-icon"
						style={{ marginLeft: 8, marginTop: 20 }}
						onClick={() => setIsOpenModels(true)}
					/>
				</div>
			</div>
		</div>
	);
};

export default Step1;
